// Compatibility shim for Refresh cart.js when Shopify StandardEvents is not present.
window.StandardEvents = window.StandardEvents || {};
if (typeof window.StandardEvents.createViewEventElement !== 'function') {
  window.StandardEvents.createViewEventElement = (BaseElement) =>
    class extends BaseElement {
      connectedCallback() {}
    };
}

// Keep the cart bundle message isolated from product-card and quick-add interactions.
document.addEventListener('DOMContentLoaded', () => {
  const addOffer = (root) => {
    if (!root || root.querySelector('.veltronics-cart-offer')) return;
    const checkout = root.querySelector('[name="checkout"], button[type="submit"].cart__checkout-button, .cart__checkout-button');
    if (!checkout) return;

    const box = document.createElement('div');
    box.className = 'veltronics-cart-offer';
    box.setAttribute('role', 'note');
    box.innerHTML = '<strong>Bundle &amp; Save</strong><span>Buying 2? Use <b>COOL2</b> for 20% off. Buying 3+? Use <b>COOL3</b> for 30% off at checkout.</span>';
    checkout.parentNode.insertBefore(box, checkout);
  };

  const scan = () => {
    addOffer(document.querySelector('cart-drawer'));
    addOffer(document.querySelector('main-cart-footer'));
  };

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
});
